export enum AvaliacaoAdministradorEnum {

  arquivado = "Arquivado",
  defeito = "Defeito",
  melhoria = "Melhoria",
  naoAvaliado = "Não avaliado",
  necessitaDocumentacao = "Necessita documentação",
  novaFuncionalidade = "Nova funcionalidade"
}
